import * as yup from 'yup';

import { ValidationError } from 'src/enums/Validation';
import { parseDecimalHours, roundToQuarterHour } from 'src/utils/decimalHours';

const MAX_HOURS_PER_DAY = 24;

export const decimalHoursSchema = yup
  .string()
  .trim()
  .required(ValidationError.default)
  .test('decimal-hours', function isDecimalHours(value) {
    if (!value) return true;

    const hours = parseDecimalHours(value);
    if (hours === null) return this.createError({ message: 'Please enter a number, for example 7.5.' });
    if (roundToQuarterHour(hours) > MAX_HOURS_PER_DAY) {
      return this.createError({ message: `You can’t track more than ${MAX_HOURS_PER_DAY} hours in a day.` });
    }

    return true;
  });
